import { cn } from "@/lib/utils";
import { Icon } from "@tabler/icons-react";

type GradientTabButtonProps = {
  icon: Icon;
  label: string;
  isActive: boolean;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  variant?: "default" | "tertiarySecondary";
};

export default function GradientTabButton({
  icon: IconComponent,
  label,
  isActive,
  onClick,
  disabled,
  className,
  variant = "default",
}: GradientTabButtonProps) {
  const isTertiarySecondary = variant === "tertiarySecondary";

  return (
    <button
      className={cn(
        "flex cursor-pointer items-center gap-3 rounded-lg border border-transparent px-6 py-3 pl-4 text-left text-sm font-medium text-text-primary hover:bg-grey-100",
        isActive &&
          isTertiarySecondary &&
          "border-tertiary-400 bg-tertiary-100 text-tertiary-400 hover:bg-tertiary-100",
        !isActive && "bg-transparent",
        className,
      )}
      disabled={disabled}
      style={
        isActive && !isTertiarySecondary
          ? {
              background:
                "linear-gradient(to bottom right, var(--color-primary-100), var(--color-secondary-100)) padding-box, linear-gradient(to bottom right, var(--color-primary-400), var(--color-secondary-400)) border-box",
            }
          : undefined
      }
      onClick={onClick}
    >
      <div
        className={cn(
          "flex w-5 items-center justify-center",
          isActive &&
            !isTertiarySecondary &&
            "[&_svg]:stroke-[url(#icon-gradient)]",
          isActive && isTertiarySecondary && "text-tertiary-400",
        )}
      >
        <IconComponent size={18} stroke={2} />
      </div>
      <span
        className={cn(
          isActive &&
            !isTertiarySecondary &&
            "bg-linear-to-r from-primary-400 to-secondary-400 bg-clip-text text-transparent",
          isActive && isTertiarySecondary && "text-tertiary-400",
        )}
      >
        {label}
      </span>
    </button>
  );
}
